import React from "react";
import classNames from "classnames";

import styles from "./Layout.css";

export default function Layout(_ref) {
  var includeHeader = _ref.includeHeader,
      headerComponent = _ref.headerComponent,
      children = _ref.children,
      className = _ref.className;

  return React.createElement(
    "div",
    null,
    includeHeader && headerComponent || null,
    React.createElement(
      "div",
      { className: classNames(styles.root, className) },
      children
    )
  );
}


// WEBPACK FOOTER //
// ./src/components/Library/Layout/Layout.js